<ul class="nav navbar-nav top-nav-bg nav-open">
	<li *ngIf="routeNavId !== rootNavId">
		<a class="d-block" href="#" (click)="clickDropdown(routeNavId, true)">
			<img alt="" class="back-svg" src="assets/images/navigation/Back.svg" />
			Back
		</a>
	</li>
	<ng-container *ngFor="let route of loopNavRoutes">
		<li
			class="ellipse"
			*ngIf="
				route.ellipseBefore &&
				!navService.shouldShowRouteLink(route, navRoutes, route.index) &&
				!navService.shouldShowRouteLink(navRoutes[route.index - 1], navRoutes, route.index)
			"
		>
			...
		</li>
		<li
			#linkLi
			*ngIf="route.ellipseBefore || route.ellipseAfter || navService.shouldShowRouteLink(route, navRoutes)"
			[class.link-active]="forceSelect === route.id"
			[routerLinkActive]="['link-active']"
			[routerLinkActiveOptions]="{ exact: route.exact }"
		>
			<a class="d-block" [routerLink]="[route.path]" [queryParams]="route.queryParams" [target]="route.openNewTab ? '_blank' : ''">
				{{ route.name }}
			</a>
		</li>
		<li
			class="ellipse"
			*ngIf="
				route.ellipseAfter &&
				!navService.shouldShowRouteLink(route, navRoutes) &&
				!navService.shouldShowRouteLink(navRoutes[route.index + 1], navRoutes)
			"
		>
			...
		</li>
		<li *ngIf="route && route.children && !route.hasSideNav" class="dropdown">
			<a class="d-block dropdown-toggle" href="#" (click)="clickDropdown(route.id)">
				{{ route.name }}
			</a>
		</li>
	</ng-container>
</ul>
